module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-latin-700-normal.woff2?227c93190fe7f82de3f802ce0b614d3b";